import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Tabs } from "../../themes/Default/components/Tabs";
import { Title } from "../../themes/Default/components/Title";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { Main } from "../../themes/Default/components/Main";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Formik } from "formik";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../services/core/Select";
import { userManagement } from "../../hooks/api/UserManagement";
import { useUserToken } from "../../hooks/core/UserToken";
import { roles } from "../../services/utils/Roles";

const Profile = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const [formErrors, setFormErrors] = useState([]);
    const { useAddUserProfileDataViewMutation, useGetUserProfileDataViewMutation, useUpdatUserProfileDataViewMutation } = userManagement;
    const [addUserProfile] = useAddUserProfileDataViewMutation();
    const [getUserProfile] = useGetUserProfileDataViewMutation();
    const [updateUserProfile] = useUpdatUserProfileDataViewMutation();
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const userId = decodedToken?.id;
    const [userProfileId, setUserProfileId] = useState([]);

    const tabs = [
        { title: t('settings.default'), isActive: true },
    ];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        console.log(values);
        if(userProfileId){
            updateUserProfile({userId, body: values}).then((result) => {
                if (result?.error) {
                    setFormErrors(result?.error?.data?.error?.violations);
                    toast.error(result.error.data.error.responseMessage);
                } else {
                    toast.info(result?.data?.info?.responseMessage);
                }
            });
        }else{
            addUserProfile({userId, body: values}).then((result) => {
                if (result?.error) {
                    setFormErrors(result?.error?.data?.error?.violations);
                    toast.error(result.error.data.error.responseMessage);
                } else {
                    toast.info(result?.data?.info?.responseMessage);
                }
            });
        }
    };

    useEffect(() => {
        getUserProfile({userId}).then((result) => {
            setUserProfileId(result?.data?.id);
            formRef.current.setValues(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{t('Prikaz podataka')}</Title>
                <Breadcrumps>
                    <Link title={t('profile.title')} icon="fa-user-pen" />
                    <Link title={t('settings.default')} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        groups: 'list_view',
                        students: 'list_view',
                        employees: 'list_view',
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select
                                        name="groups"
                                        label={t("groups.title")}
                                        options={prepareSelect([
                                            { id: 'list_view', name: t("List view") },
                                            { id: 'grid_view', name: t("Grid view") },
                                        ])}
                                        onChange={handleChange}
                                        selectedValue={values.groups}
                                        error={formErrors?.groups}
                                        searchVisible={false}
                                    />
                                </Field>
                                <Field>
                                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                                    <>
                                        <Select
                                            name="students"
                                            label={t("students.title")}
                                            options={prepareSelect([
                                                { id: 'list_view', name: t("List view") },
                                                { id: 'grid_view', name: t("Grid view") },
                                            ])}
                                            onChange={handleChange}
                                            selectedValue={values.students}
                                            error={formErrors?.students}
                                            searchVisible={false}
                                        />
                                    </>
                                )}  
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.DIRECTOR) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                                    <>
                                        <Select
                                            name="employees"
                                            label={t("employees.title")}
                                            options={prepareSelect([
                                                { id: 'list_view', name: t("List view") },
                                                { id: 'grid_view', name: t("Grid view") },
                                            ])}
                                            onChange={handleChange}
                                            selectedValue={values.employees}
                                            error={formErrors?.employees}
                                            searchVisible={false}
                                        />
                                    </>
                                )}  
                                </Field>
                                <Field></Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default Profile;
